export const OpportunityContractLookupType = {
  Opportunity: 'Opportunity',
  Contract: 'Contract'
};
